 const api = {}

export default {
    install(Vue) {
      Object.defineProperty(Vue.prototype, 'api', {
        value: api,
        writable: false,
      });
    },
};